import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolAction } from '../symbol.action';
import { SymbolTranslator } from '../symbol.translator';

type IDependencies = IClientApiDependencySegment;

export const createSymbolEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolAction.create.started),
  mergeMap((params) => {
    return dependencies.api.createSymbol(SymbolTranslator.toApi(params)).pipe(
      mergeMap((response) => {
        return [
          SymbolAction.create.done({ params, result: { symbolId: response.id } }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolAction.create.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
